import React from 'react';
import { Box, Card, CardContent, styled, Typography } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/SmartToyOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const RootCard = styled(Card)(({ theme }) => ({
	borderRadius: theme.spacing(2),
	padding: theme.spacing(2),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2),
	boxShadow: 'none',
	border: `1px solid ${theme.palette.divider}`,
	width: '100%',
	maxWidth: 1250,
	backgroundColor: theme.palette.grey[200],
}));

const InfoRow = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	gap: theme.spacing(2),
	flexWrap: 'wrap',
	width: '100%',
}));

const InfoBox = styled(Box)(({ theme }) => ({
	flex: 1,
	minWidth: 120,
	backgroundColor: theme.palette.grey[50],
	borderRadius: theme.spacing(1.5),
	padding: theme.spacing(2),
	textAlign: 'center',
}));

const Footer = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'start',
	fontSize: 14,
	marginTop: 15,
	color: theme.palette.text.secondary,
	gap: theme.spacing(1),
}));

const CathenaVaultCard: React.FC = () => {
	const selectedVault = useSelector((state: RootState) => state.vault);
	const selectedAsset = selectedVault.token.find(
		(d) => d.name === selectedVault.selectedToken,
	);
	const queryParams = new URLSearchParams(location.search);
	const devMode = queryParams.get('devmode');
	const minAllowed = devMode ? 0.1 : selectedAsset?.minAllowed || 0;

	return (
		<RootCard>
			<CardContent>
				<Box display="flex" alignItems="start" gap={1}>
					<AccountBalanceWalletIcon
						fontSize="large"
						style={{
							color: '#fff',
							backgroundColor: '#000',
							padding: 4,
							marginTop: 10,
							marginRight: 5,
							borderRadius: 100,
						}}
					/>
					<Box style={{ width: '100%' }}>
						<Typography variant="subtitle1" fontWeight={500}>
							Welcome to Cathena Vault! 🎉
						</Typography>
						<Box height={5} />
						<Typography variant="body2" color="text.secondary">
							Start earning passive income with our automated
							yield farming. Your funds work 24/7 while you sleep.
						</Typography>
						<Box height={15} />
						<InfoRow>
							<InfoBox>
								<Typography
									variant="h6"
									color="#009d2a"
									fontWeight="bold"
								>
									7.1% APY
								</Typography>
								<Box height={5} />
								<Typography
									variant="caption"
									color="text.secondary"
									component={'p'}
									fontWeight={500}
								>
									Current yield
								</Typography>
							</InfoBox>

							<InfoBox>
								<Typography variant="h6" fontWeight="bold">
									No Lockup
								</Typography>
								<Box height={5} />
								<Typography
									variant="caption"
									color="text.secondary"
									component={'p'}
									fontWeight={500}
								>
									Withdraw anytime
								</Typography>
							</InfoBox>

							<InfoBox>
								<Typography variant="h6" fontWeight="bold">
									Min {minAllowed}
									{selectedVault.currency}
								</Typography>
								<Box height={5} />
								<Typography
									variant="caption"
									color="text.secondary"
									component={'p'}
									fontWeight={500}
								>
									Start small
								</Typography>
							</InfoBox>
						</InfoRow>
						<Footer>
							<Typography
								variant="body2"
								alignItems={'center'}
								display={'flex'}
							>
								<ShieldOutlinedIcon
									style={{ fontSize: 20, marginRight: 5 }}
								/>{' '}
								Audited smart contracts • $12.5M+ TVL • Daily
								compounding
							</Typography>
						</Footer>
					</Box>
				</Box>
			</CardContent>
		</RootCard>
	);
};

export default CathenaVaultCard;
